// extracted by mini-css-extract-plugin
export default {"classes":"Spinner_classes__xb2aU"};